import React from 'react';
import { FaCheckCircle, FaExclamationCircle, FaTimes } from 'react-icons/fa';
import styles from '../css/Popup.module.css';

const Popup = ({ message, type = 'success', onClose }) => {
  return (
    <div className={styles.popupOverlay} onClick={onClose}>
      <div className={styles.popupContent} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={onClose}>
          <FaTimes size={20} />
        </button>
        
        <div className={styles.iconContainer}>
          {type === 'success' ? (
            <FaCheckCircle size={60} className={styles.successIcon} />
          ) : (
            <FaExclamationCircle size={60} className={styles.errorIcon} />
          )}
        </div>

        <h3 className={styles.title}>
          {type === 'success' ? 'Success!' : 'Error!'}
        </h3>

        <p className={styles.message}>{message}</p>

        <button className={styles.okButton} onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
};

export default Popup;